export const sleep = (seconds: number) => {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
};



// WEBPACK FOOTER //
// /Volumes/workplace/src/utils/sleep.ts